<h1 class="mb-4">Skrzynka odbiorcza</h1>
<div class="flex flex-col mb-4">
  <p class="font-bold mb-1">Filtrowanie</p>
  <div class="flex gap-2 flex-wrap">
    <p-button
      (click)="setInboxContext(InboxType.TO_RECEIVE)"
      [icon]="inboxType() === InboxType.TO_RECEIVE ? 'pi pi-times' : ''"
      [label]="'Do odbioru'"
      [styleClass]="
        'customInfoButton bolder' +
        (inboxType() !== InboxType.TO_RECEIVE ? ' outlined silver' : '')
      "
      iconPos="right"
      size="small"
    />
    <p-button
      (click)="setInboxContext(InboxType.RECEIVED)"
      [icon]="inboxType() === InboxType.RECEIVED ? 'pi pi-times' : ''"
      [label]="'Odebrane'"
      [styleClass]="
        'customInfoButton bolder' +
        (inboxType() !== InboxType.RECEIVED ? ' outlined silver' : '')
      "
      iconPos="right"
      size="small"
    />
    <p-button
      (click)="setInboxContext(InboxType.ARCHIVED)"
      [icon]="inboxType() === InboxType.ARCHIVED ? 'pi pi-times' : ''"
      [label]="'Zarchiwizowane'"
      [styleClass]="
        'customInfoButton bolder' +
        (inboxType() !== InboxType.ARCHIVED ? ' outlined silver' : '')
      "
      iconPos="right"
      size="small"
    />
  </div>
</div>
<div class="wide">
  <p-table
    #table
    (onPage)="onPrimePageChange($event)"
    (onSort)="onPrimeSortChange($event)"
    [(selection)]="selectedMessages"
    [customSort]="true"
    [lazy]="true"
    [loading]="isDataLoading()"
    [paginatorStyleClass]="'customPrimePaginator'"
    [paginator]="true"
    [rowSelectable]="isRowSelectable"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rows]="tablePage()?.size || 10"
    [tableStyle]="{ 'min-width': '50rem' }"
    [totalRecords]="tablePage()?.totalElements || 0"
    [value]="rows()"
    dataKey="id"
    [scrollable]="true"
    scrollHeight="flex"
  >
    <ng-template #header>
      <tr>
        @if (rows() | hasDocumentToReceive) {
          <td></td>
        }
        @if (inboxType() !== InboxType.TO_RECEIVE) {
          <td class="table-filter-cell" style="width: 4rem">
            <p-tableHeaderCheckbox/>
          </td>
        }
        <th pSortableColumn="nadawca">
          <div class="flex items-center gap-2">
            Nadawca
            <p-sortIcon field="nadawca"/>
          </div>
        </th>
        <th pSortableColumn="dataWplywu">
          <div class="flex items-center gap-2">
            Czas nadania
            <p-sortIcon field="dataWplywu"/>
          </div>
        </th>
        <th pSortableColumn="dataPoswiadczenia">
          <div class="flex items-center gap-2">
            Czas poświadczenia
            <p-sortIcon field="dataPoswiadczenia"/>
          </div>
        </th>
        <th alignFrozen="right" pFrozenColumn>Akcje</th>
      </tr>
      <tr>
        @if (rows() | hasDocumentToReceive) {
          <td></td>
        }
        @if (inboxType() !== InboxType.TO_RECEIVE) {
          <td></td>
        }
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'nadawca')"
            pInputText
            ariaLabel="Filtruj po nadawcy"
          />
        </td>
        <td class="table-filter-cell" style="width: 200px; min-width: 200px">
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'dataWplywu')"
            (onSelect)="onPrimeFilterChange($event, 'dataWplywu')"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            class="w-full"
            dateFormat="dd-mm-yy"
            ariaLabel="Filtruj po dacie wpływu"
          />
        </td>
        <td class="table-filter-cell" style="width: 200px; min-width: 200px">
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
            (onSelect)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            class="w-full"
            dateFormat="dd-mm-yy"
            ariaLabel="Filtruj po dacie poświadczenia"
          />
        </td>
        <td alignFrozen="right" pFrozenColumn></td>
      </tr>
    </ng-template>
    <ng-template #body let-document>
      <tr
        [ngClass]="{
          'unread-row': document.statusDokumentu === DocumentStatus.PRZY,
        }"
      >
        @if (rows() | hasDocumentToReceive) {
          <td>
            <div
              [ngClass]="{
                'blue-dot': document.statusDokumentu === DocumentStatus.PRZY,
              }"
            ></div>
          </td>
        }
        @if (inboxType() !== InboxType.TO_RECEIVE) {
          <td>
            <p-tableCheckbox
              [value]="document"
              [disabled]="document.statusDokumentu === DocumentStatus.PRZY"
              ariaLabel="Zaznaczanie wiersza tablicy"
            />
          </td>
        }
        <td>{{ document.nadawca }}</td>
        <td>
          {{
            document.dataWplywu
              ? (document.dataWplywu | date: 'yyyy-MM-dd HH:mm:ss')
              : '-'
          }}
        </td>
        <td>
          {{
            document.dataPoswiadczenia
              ? (document.dataPoswiadczenia | date: 'yyyy-MM-dd HH:mm:ss')
              : '-'
          }}
        </td>
        <td alignFrozen="right" pFrozenColumn class="h-16 align-middle">
          @if (document.statusDokumentu === DocumentStatus.PRZY) {
            <p-button
              [styleClass]="'customInfoButton'"
              size="small"
              [label]="'Odbierz'"
              [disabled]="!isReceiving"
              (onClick)="
                openShowDocumentModalAndApplicationVisualization(document)
              "
            />
          } @else {
            <div class="flex items-center h-full gap-3 justify-end">
              @if (inboxType() !== InboxType.ARCHIVED) {
                <p-button
                  type="button"
                  class="icon_correspondence"
                  (click)="correspond(document)"
                  ariaLabel="Koresponduj w sprawie"
                  pTooltip="Koresponduj w sprawie"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                >
                </p-button>
              }
              <p-button
                type="button"
                (click)="openShowDocumentModal(document)"
                ariaLabel="Zobacz szczegóły"
                pTooltip="Zobacz szczegóły"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <i class="pi pi-eye icon_show" aria-hidden="true"></i>
              </p-button>
            </div>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-between gap-2 mt-4">
    <div class="flex gap-2 mt-2">
      @if (inboxType() === InboxType.ALL || inboxType() === InboxType.RECEIVED) {
        <p-button
          styleClass="customInfoButton outlined bolder"
          size="small"
          [label]="'Archiwizuj wybrane'"
          [disabled]="!selectedMessages.length"
          (click)="archiveDocumentDialog()"
        />
      }
      @if (inboxType() === InboxType.ARCHIVED) {
        <p-button
          styleClass="customInfoButton outlined bolder"
          size="small"
          [label]="'Cofnij archiwizację wybranych'"
          [disabled]="!selectedMessages.length"
          (click)="restoreFromArchiveDocumentDialog()"
        />
      }
      @if (inboxType() !== InboxType.TO_RECEIVE) {
        <p-button
          (click)="exportSelected()"
          [disabled]="!selectedMessages.length"
          [label]="'Eksportuj wybrane'"
          size="small"
          styleClass="customInfoButton outlined bolder"
        />
      }
    </div>
  </div>
</div>
<div class="narrow">
  <div class="flex flex-col gap-4 mb-6">
    <div class="flex flex-col gap-2">
      <label for="nadawca" class="font-bold">Nadawca</label>
      <input
        (input)="onPrimeFilterChangeMobile($event.target, 'nadawca')"
        id="nadawca"
        [(ngModel)]="tableFilters.sender"
        pInputText
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="dataWplywu" class="font-bold">Czas nadania</label>
      <p-date-picker
        (onClear)="onPrimeFilterChange($event, 'dataWplywu')"
        (onSelect)="onPrimeFilterChange($event, 'dataWplywu')"
        [readonlyInput]="true"
        [showClear]="true"
        appendTo="body"
        class="w-full customDatePicker"
        dateFormat="dd-mm-yy"
        [(ngModel)]="tableFilters.sentDate"
        [showIcon]="true"
        [iconDisplay]="'input'"
        ariaLabel="Filtruj po dacie wpływu"
        inputId="dataWplywu"
      />
    </div>
    <div class="flex flex-col gap-2 w-full">
      <label for="dataPoswiadczenia" class="font-bold"
      >Czas poświadczenia</label
      >
      <p-date-picker
        (onClear)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
        (onSelect)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
        [readonlyInput]="true"
        [showClear]="true"
        appendTo="body"
        class="w-full customDatePicker"
        dateFormat="dd-mm-yy"
        [(ngModel)]="tableFilters.certificationDate"
        [showIcon]="true"
        [iconDisplay]="'input'"
        ariaLabel="Filtruj po dacie poświadczenia"
        inputId="dataPoswiadczenia"
      />
    </div>
    <div class="flex flex-row-reverse gap-2">
      <p-button
        type="button"
        styleClass="customInfoButton outlined"
        (click)="clearFilters()"
        ariaLabel="Wyczyść filtry"
      >
        <span class="font-bold">Wyczyść filtry</span>
      </p-button>
    </div>
  </div>
  @if (isDataLoading()) {
    <div class="flex justify-center">
      <p-progress-spinner
        class="customProgressSpinner"
        strokeWidth="6"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '50px', height: '50px' }"
      >
      </p-progress-spinner>
    </div>
  } @else {
    <div class="flex flex-col gap-10">
      @for (document of rows() || []; track document.id; let index = $index) {
        <p-card
          class="customMobileCard"
          [style]="{
            background:
              document.statusDokumentu === DocumentStatus.ODBR
                ? 'transparent'
                : '#F3F9FE',
          }"
        >
          @if (document.statusDokumentu === DocumentStatus.ODBR) {
            <div class="mb-2">
              <p-checkbox
                [(ngModel)]="selectedMessages"
                [value]="document"
                ariaLabel="Zaznaczanie wiersza tablicy"
              ></p-checkbox>
            </div>
          } @else {
            <div
              class="mb-2"
              [ngClass]="{
                'blue-dot': document.statusDokumentu === DocumentStatus.PRZY,
              }"
            ></div>
          }
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Nadawca"
              [data]="document.nadawca"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            <hr class="limiter"/>
            <app-preview-data-wrapper
              label="Czas nadania"
              [dataType]="PreviewDataType.DATE"
              [data]="document.dataWplywu"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            <hr class="limiter"/>
            <app-preview-data-wrapper
              label="Czas poświadczenia"
              [dataType]="PreviewDataType.DATE"
              [data]="document.dataPoswiadczenia"
              [additionalCssClasses]="'font-bold'"
            ></app-preview-data-wrapper>
            @if (document.statusDokumentu === DocumentStatus.PRZY) {
              <div class="flex justify-end gap-5 mt-5">
                <p-button
                  [styleClass]="'customInfoButton'"
                  [label]="'Odbierz'"
                  [disabled]="!isReceiving"
                  (onClick)="
                    openShowDocumentModalAndApplicationVisualization(document)
                  "
                />
              </div>
            } @else {
              <div class="flex justify-end gap-5 mt-5">
                <p-button
                  (click)="correspond(document)"
                  label="Koresponduj w sprawie"
                  styleClass="customInfoButton outlined"
                />
                <p-button
                  (click)="openShowDocumentModal(document)"
                  label="Szczegóły"
                  styleClass="customInfoButton outlined"
                />
              </div>
            }
          </div>
        </p-card>
      }
      <div class="flex gap-2 sticky-actions w-full justify-evenly">
        @if (inboxType() === InboxType.ALL || inboxType() === InboxType.RECEIVED) {
          <p-button
            styleClass="customInfoButton outlined bolder"
            [label]="'Archiwizuj wybrane'"
            [disabled]="!selectedMessages.length"
            (click)="archiveDocumentDialog()"
          />
        }
        @if (inboxType() === InboxType.ARCHIVED) {
          <p-button
            styleClass="customInfoButton outlined bolder"
            [label]="'Cofnij archiwizację wybranych'"
            [disabled]="!selectedMessages.length"
            (click)="restoreFromArchiveDocumentDialog()"
          />
        }
        @if (inboxType() !== InboxType.TO_RECEIVE) {
          <p-button
            (click)="exportSelected()"
            [disabled]="!selectedMessages.length"
            [label]="'Eksportuj wybrane'"
            styleClass="customInfoButton outlined bolder"
          />
        }
      </div>
    </div>
  }
  <p-paginator
    (onPageChange)="onPrimePageChange($event)"
    [pageLinkSize]="3"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="tablePage()?.size || 10"
    [totalRecords]="tablePage()?.totalElements || 0"
  />
</div>
